<script>

import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
	components: {
        VueApexCharts
    },
  props: {
    params: {
      type: Object,
      default: function () {
        return { }
      }
    },
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "radialBar"
    },
    colors: {
      type: Array,
      default: function () {
        return ['#1ab7ea', '#0084ff', '#39539E', '#0077B5']
      }
    },
    colorsByLabel: {
      type: Object,
      default: function () {
        return { }
      }
    },
    show_last_modification: {
      type: Boolean,
      default: false
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
			type: Boolean,
			default: false
    },
    collection: "",
  },
  // computed: {
  //     maxVal() {
  //         return this.maxValue
  //     }
  // },
  data: function () {
      return {
      name: window.name,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      maxValue: 0,
      series: [],
      chartColors: [],
      chartOptions: {
        chart: {
          height: 300,
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              }
              // value: {
              //   formatter: (val) => (val * maxValue) / 100 ,
              // },
            }
          }
        },
        labels: [],
        legend: {
          show: true,
          floating: true,
          Size: '12px',
          position: 'left',
          offsetX: 0,
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0
          },
          // formatter: function(seriesName, opts) {
          //   // return seriesName + ":  " + (opts.w.globals.series[opts.seriesIndex] * maxValue) /100
          // },
          itemMargin: {
            vertical: 1
          }
        },
        responsive: [{
          breakpoint: 300,
          options: {
            legend: {
                show: false
            }
          }
        }]
      },
    }
  },
  methods: {
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('DPie Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      let source = that.source
      if (that.range) {
        if (that.start > 0) source = source + '&start=' + that.start.toString()
        if (that.end > 0) source = source + '&end=' + that.end.toString()
      }
      axios
      .post(baseURL + source, that.params)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined || response.data.updated === undefined) {
              console.error('DPie Error - data not defined in source file.')
              return
            }
            // if (Object.keys(that.colorsByLabel).length === 0) {
            //   that.chartColors = ['#1ab7ea', '#0084ff', '#39539E', '#0077B5']
            // }
            let c = 0
            
            const counts = response.data.data.map(entry => {
              return parseInt(entry.count) || 0
            })
            that.maxValue = Math.max(...counts)
            response.data.data.map(entry => {
              if (entry.label !== undefined ) that.chartOptions.labels.push(entry.label.replace(/_/g, " "))
              if (that.colorsByLabel !== undefined && Object.keys(that.colorsByLabel).length > 0) {
                that.chartColors.push(that.colorsByLabel[entry.label])
              } else {
                that.chartColors.push(that.colors[c])
                c += 1
                if (c === that.colors.length) c = 0
              }
              if (entry.count !== undefined && entry.count > 0) {
                that.series.push((entry.count/that.maxValue)*100)
              }
            })
            // if (that.colorsByLabel === undefined || Object.keys(that.colorsByLabel).length === 0) {
            //   that.chartOptions.colors = that.colors
            // }
            // that.chartColors = that.colors
            // that.chartOptions.colors = that.colors
            that.lastUpdated = new Date(response.data.updated).toLocaleString()
            that.isBusy = false
            that.$refs.pieChart.updateOptions({
              legend: {
                formatter: function(seriesName, opts) {
                return seriesName + ":  " + parseInt((opts.w.globals.series[opts.seriesIndex] * that.maxValue) /100)
                }
              }
            })
          }
          else if (response.status === 404) {
            console.error('DPie Error - Source file not found.');
            return
          }
      })
			.catch(function (error) {
        console.error('Error loading DPie data. Error:', error.response);
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			})
    }
  },
  created: function() {
    this.chartOptions.chart.type = this.type
    this.getData()
    this.chartOptions.colors = this.chartColors
  }
}
</script>

<template>
  <div style="height:320px">
    <div style="text-align:left !important;">
      <!-- <VueApexCharts type="radialBar" height="295" :options="chartOptions" :series="series"></VueApexCharts> -->
      <VueApexCharts :type="type" height="295" :options="chartOptions" :series="series" ref="pieChart"></VueApexCharts>

    </div>
  </div>
</template>

<style scoped>
  .apexcharts-legend {
      padding-right: 80px;
      line-height: 5px;
      font-size: 8px;
  }
</style>
